import { createAction, makeActionTrackable } from '@lingoda/core';

export default makeActionTrackable(createAction('auth/LOGOUT'));
